import { Link } from 'react-router-dom'

const GlobalFooter = () => {
  const footerSections = [
    {
      title: 'Member Services',
      links: [
        { name: 'Aesthetics & Anti-Aging', href: '/member-services/aesthetics-anti-aging' },
        { name: 'Art Escrow & Consulting', href: '/member-services/art-escrow-consulting' },
        { name: 'Black Car Service', href: '/member-services/black-car-service' },
        { name: 'Education Consulting', href: '/member-services/education-consulting' },
        { name: 'Invite-Only Lounge', href: '/member-services/invite-only-lounge' },
        { name: 'Personal Travel Planner', href: '/member-services/personal-travel-planner' },
        { name: 'Private Dining', href: '/member-services/private-dining' },
        { name: 'Private Jet Charter', href: '/member-services/private-jet-charter' },
        { name: 'Ticketing & Events', href: '/member-services/ticketing-events' },
        { name: 'Yacht Charter', href: '/member-services/yacht-charter' },
      ]
    },
    {
      title: 'Bespoke Shopping',
      links: [
        { name: 'Artwork', href: '/bespoke-shopping/artwork' },
        { name: 'Cigars', href: '/bespoke-shopping/cigars' },
        { name: 'Diamonds', href: '/bespoke-shopping/diamonds' },
        { name: 'Estates', href: '/bespoke-shopping/estates' },
        { name: 'Fine Wine', href: '/bespoke-shopping/fine-wine' },
        { name: 'Moutai', href: '/bespoke-shopping/moutai' },
        { name: 'Watches', href: '/bespoke-shopping/watches' },
        { name: 'Whiskey', href: '/bespoke-shopping/whiskey' },
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Membership Enquiry', href: '/membership-enquiry' },
        { name: 'Terms & Conditions', href: '/terms' },
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Newsletter', href: '/editorial' },
        { name: 'Contact Us', href: '/contact' },
      ]
    }
  ]

  const languages = [
    { name: 'English', code: 'en', active: true },
    { name: '繁體', code: 'zh-hk', active: false },
    { name: '簡體', code: 'zh-cn', active: false },
  ]

  return (
    <footer className="fga-global-footer">
      {/* Main Footer Content */}
      <div className="fga-footer-main-content">
        <div className="fga-footer-container">
          {/* Three Columns */}
          <div className="fga-footer-columns">
            {footerSections.map((section) => (
              <div key={section.title} className="fga-footer-column">
                <h3 className="fga-footer-column-title">
                  {section.title === 'Member Services' ? (
                    <Link to="/member-services" style={{ cursor: 'pointer !important', textDecoration: 'none' }}>
                      {section.title}
                    </Link>
                  ) : section.title === 'Bespoke Shopping' ? (
                    <Link to="/bespoke-shopping" style={{ cursor: 'pointer !important', textDecoration: 'none' }}>
                      {section.title}
                    </Link>
                  ) : (
                    section.title
                  )}
                </h3>
                <ul className="fga-footer-links-list">
                  {section.links.map((link) => (
                    <li key={link.name} className="fga-footer-link-item">
                      <Link to={link.href} className="fga-footer-link" style={{ cursor: 'pointer !important', textDecoration: 'none' }}>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Language Switcher */}
          <div className="fga-footer-language-switcher">
            {languages.map((lang, index) => (
              <span key={lang.code} className="fga-footer-language-item">
                <span className={`fga-footer-language-text ${lang.active ? 'active' : ''}`}>
                  {lang.name}
                </span>
                {index < languages.length - 1 && (
                  <span className="fga-footer-language-separator">｜</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Legal Section */}
      <div className="fga-footer-legal-section">
        <div className="fga-footer-legal-text">
          fgaprestige.com © 2025 All rights reserved.
        </div>
      </div>
    </footer>
  )
}

export default GlobalFooter